import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {CoachModel} from '../models/coach.model';
import {CoachService} from '../service/coach.service';
import {NavController, Platform} from '@ionic/angular';

@Component({
    selector: 'app-coach-profile-page',
    templateUrl: 'coach-profile.page.html',
    styleUrls: ['coach-profile.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class CoachProfilePage implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    environment = null;

    template_coach_id = 0;

    coach: CoachModel = null;
    coachPromise: Promise<CoachModel> = null;
    coachValid = false;
    platform = 'website';

    constructor(
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private coachService: CoachService,
        private activatedRoute: ActivatedRoute,
        private navCtrl: NavController,
        private router: Router,
        private platformService: Platform,
    ) {
        this.environment = environment;
        this.platform = this.authService.appMobile ? 'mobile' : 'website';

        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.coachValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.coachValid = false)
        );

        this.template_coach_id = Number(this.activatedRoute.snapshot.paramMap.get('coachId'));

        if (this.template_coach_id <= 0) {
            this.goBack();
        }
    }

    ngOnInit(): void {
    }

    ionViewWillEnter() {
        if (this.coach === null || !this.coachValid) {
            this.coachPromise = this.coachService.getCoach(this.template_coach_id);
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Coach Profile');

        if (this.coach === null || !this.coachValid) {
            this.coachPromise.then(data => {
                this.coach = data;
                this.coachValid = true;
            });
        }
    }

    goBack() {
        this.navCtrl.back();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
